import Loader from './loader';

let initFlag = false;

const getBlackbox = options => new Promise((resolve) => {
	if (!initFlag) {
		window.io_global_object_name = 'IGLOO';
		window.IGLOO = window.IGLOO || {
			bb_callback: (blackbox, finished) => resolve({ blackbox, finished }),
			install_flash: false,
			loader: {
				// this is for reverse proxy feature (https://one.nexon.com/iojs/5.2.2/static_wdp.js -> look up iovation CDN)
				// don't change this path because we are using www.nexon.com/iojs and one.nexon.com/iojs
				uri_hook: (options && options.uri_hook) || '/iojs',
				version: (options && options.version) || 'general5',
				trace_handler(msg) {
					console.log(msg);
				},
			},
		};
		Loader();
		initFlag = true;
	} else if (window.IGLOO.getBlackbox) {
		const { blackbox, finished } = window.IGLOO.getBlackbox();
		resolve({ blackbox, finished });
	} else {
		resolve({ blackbox: '', finished: false });
	}
});


export default {
	install(Vue) {
		Vue.prototype.$iovation = {
			getBlackbox,
		};
	},
};

export { getBlackbox };
